import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

export const ContentCreateEvent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  .react-datepicker-popper {
    z-index: 2;
  }
  .MuiOutlinedInput-input {
    padding: 10px;
    font-size: 14px;
  }
  .font-w-600 {
    font-weight: 600;
    font-size: 16px;
  }
  .section-title {
    font-size: 1rem;
    font-weight: 700;
    color: ${({ theme }) => theme.neutral.gray[3200]};
  }
  .MuiRadio-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.button.primary};
  }
  .user-assign-section {
    background-color: ${({ theme }) => theme.neutral.gray[100]};
    width: 98%;
    padding: 10px 0;
  }
  .speaker-section {
    display: grid;
    grid-template-areas: "heading link" "field field";
    padding-left: 10px;
    padding-right: 10px;
  }
  .user-select {
    grid-area: field;
  }
  .w-98 {
    width: 98% !important;
  }
`;

export const ContainerBack = styled.div`
  display: grid;
  grid-template-columns: 21vw 1fr;
`;

export const ContentBack = styled.div``;

export const ButtonBack = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 20%;
  height: 25px;
  margin: 0px auto;
  text-align: left;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.neutral.gray[400]};
  height: 1px;
  width: 96.5%;
`;

export const ButtonLink = styled.a`
  cursor: pointer;
  grid-area: link;
  justify-self: flex-end;
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  grid-gap: 0.2em;
  padding: 0px 11px;
  grid-template-areas: "heading link" "field field";
  grid-template-columns: 2fr 1fr;
  ${(props) => (props.OnlyAssigned ? `z-index:3;` : ``)}
  ${(props) => (props.OnlyAssigned ? `background: ${props.theme.neutral.white};` : ``)}
  border-radius: 9px;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.text.secondary};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.neutral.gray[1300]};
  }

  .css-1hb7zxy-IndicatorsContainer {
    div:nth-child(1) {
      display: ${(props) => (props.users ? "none" : "")};
    }
  }
  .css-xb97g8 {
    display: ${(props) => (props.users ? "none" : "")};
  }
`;

export const ButtonCreateEvent = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9em;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;

  color: ${({ theme }) => theme.neutral.white};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  :hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;

export const List = styled.ul`
  padding-left: 1em;
  width: 345px;
  margin-top: -22px;
  margin-bottom: 0;
  ${(props) => props.OnlyAssigned && `z-index: 2;`}
  ${(props) => props.OnlyAssigned && `background: ${props.theme.neutral.white};`}
  ${(props) => props.OnlyAssigned && `border-radius: 5px;`}
`;

export const Item = styled.li`
  list-style: none;
  line-height: 2em;
  display: grid;
  grid-template-columns: 21em 2em;
  border-radius: 7px;

  &:hover {
    background: ${({ theme }) => theme.neutral.gray[800]};
  }
  span {
    display: flex;
    float: right;
    margin-right: 1em;
    font-size: 23px;
    color: ${({ theme }) => theme.primary.purple};
    cursor: pointer;
    align-items: center;
  }
  p {
    margin: 0 0 0 8px;
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
    };
  },
};

export const TextTitleList = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2300]};
  font-size: 18px;
`;

export const InputField = styled.input``;

export const UploadImageContainer = styled.div`
  margin: 0px;
  width: 98% !important;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
  border-top: none;
  margin-top: 10px;
`;

export const ShowImageContainer = styled.img`
  width: 98% !important;
  height: 100%;
`;

export const ContentPortal = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  height: 90vh;
  width: 90vw;
  margin: auto;
  margin-top: 2%;
`;
export const HeaderContent = styled.div`
  padding: 1em;
  height: 3em;
  svg {
    float: right;
    cursor: pointer;
  }
`;
export const InfoContent = styled.div`
  padding: 2em;
  overflow-y: auto;
  height: 82vh;
`;

export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  height: 43.21px;
  max-width: 108px;
  max-height: 36px;
  margin-right: 10px;
  outline: none;
  border: none;
  box-shadow: none;
  &:hover {
    transform: translateY(-1px);
    cursor: pointer;
    text-decoration: underline;
  }
`;
export const useStyles = makeStyles((MUITheme) => ({
  contentFormForEvent: {
    width: "96.5%",
    height: "fit-content",
    backgroundColor: MUITheme.palette.background.paper,
    margin: "1.5em",
  },
}));
